import { useNavigate } from 'react-router-dom';
import { PageHeading } from '@portal_components/components/PageHeading';
import { MeterPointDetailsForm } from '../elements/MeterPointDetailsForm/MeterPointDetailsForm';
import { useDefinedParams } from '../hooks/useDefinedParams';
import { usePortalQuery, EHttpMethod } from '../hooks/usePortalQuery';
import { EMpanAssignmentMode, EMpanEditMode, SearchMeterPointDetails } from '../types';
import { useQueryClient } from '@tanstack/react-query';
import { EUserRole } from '@portal_components/types';
import { useUserInfo } from '../hooks/useUserInfo';
import { FormProvider, useForm } from 'react-hook-form';
import { FormRadioButtonGroup } from '@portal_components/components/FormRadioButtonGroup';

export const EditSiteDetailsPage = () => {
  const { userInfo } = useUserInfo();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [customerGroupId, contractId, mprn] = useDefinedParams(['customerGroupId', 'contractId', 'mprn']);

  const methods = useForm<{ editMode?: EMpanEditMode }>({
    values: {
      editMode: EMpanEditMode.EDIT
    }
  });

  const [editMode] = methods.watch(['editMode']);

  const { data: meterPointDetailsResult, isLoading: meterPointDetailsLoading } = usePortalQuery<SearchMeterPointDetails>(
    EHttpMethod.GET,
    `meter-point-details/${contractId}/${mprn}`,
    `meter-point-details-${contractId}-${mprn}`,
    true,
    undefined,
    undefined,
    undefined,
    undefined,
    600000,
    600000
  );

  const onSubmit = () => {
    queryClient.resetQueries({ queryKey: [`meter-point-details-${contractId}-${mprn}`] });
    navigate(-1);
  };

  if (!userInfo || userInfo.role === EUserRole.READONLY_USER) return <p className="text-center">You do not have permission to edit site details.</p>;

  if (!meterPointDetailsResult || meterPointDetailsLoading) {
    return null;
  }

  // remove unnecessary properties of query result
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { jobHistory, appointmentActive, contractType, ...meterPointDetails } = meterPointDetailsResult;

  return (
    <div className="flex flex-col justify-start">
      <PageHeading
        title="Edit Existing Site Meter Point Details"
        navigationButtons={[
          {
            icon: '/back.svg',
            title: 'Back',
            path: -1,
            className: 'h-6 w-6'
          }
        ]}
      />
      <FormProvider {...methods}>
        <form>
          <FormRadioButtonGroup
            title="Select Edit Operation"
            name="editMode"
            buttons={[
              { title: 'Edit', value: EMpanEditMode.EDIT },
              { title: 'Transfer', value: EMpanEditMode.TRANSFER },
              { title: 'Terminate', value: EMpanEditMode.TERMINATE }
            ]}
          />
        </form>
      </FormProvider>
      <MeterPointDetailsForm
        mpan={mprn}
        contractId={contractId}
        customerGroupId={customerGroupId}
        mode={EMpanAssignmentMode.EDIT}
        editMode={editMode}
        existingMeterPointDetails={meterPointDetails}
        onSubmit={onSubmit}
      />
    </div>
  );
};
